<app-card-container [cards]="appCards$ | async" (clicked)="switchApp($event)"></app-card-container>
